import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bestselling" }

import Blockquotes from '@/components/public/Blockquotes.vue'
// @ts-ignore
import { testimonials } from '@/assets.v2/js/pagesSite.js'
import { onMounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Bestselling',
  setup(__props) {

onMounted(() => {
  testimonials()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "billing-data__title" }, " Bestselling Authors Rave About Shortform! ", -1)),
    _createVNode(Blockquotes, { content: "partners" })
  ]))
}
}

})